'use strict';

const jQuery = require('jquery');

const Container = require('./../../core/container');
const Loader = require('./../../services/loader');
const Translator = require('./../../core/translator');
const Zone = require('./../../services/structure/zone');
const UserPrefRepo = require('../../bundles/content/repository/UserPreferenceRepository');
const FormBuilder = require('../form');
const Notifier = require('./../../services/notifier');
const translator = require('../../core/translator');

module.exports.init = () => {
  let $panelFullPage = Container.get('$toolbar').find('.cloud-panel-fullpage');

  if (!$panelFullPage.hasClass('d-none')) {
    $panelFullPage.addClass('d-none');
  }

  Loader.start();

  Zone.setSmallPanel(Translator.translate('debug'), getSmallPanelContent());
  setTimeout(function() {
    Zone.setFullPanel(Translator.translate('debug'), getFullPanelContent());
  }, 100);

  Loader.stop();
};

const getSmallPanelContent = () => {
  return `<p>${translator.translate('debug_description')}</p>`;
};

const getFullPanelContent = () => {
  let $container = jQuery('<div class="mt-3 dev-mode-container"/><div class="cloud-row"/><div class="cloud-col-2"/>');

  UserPrefRepo.find('dev-mode').then((value) => {
    let devMode = (value.enabled || '0');
    let form = FormBuilder.getForm({
      'elements': {
        'dev_mode': {
          'type': 'switch',
          'label': Translator.translate('debug_dev_mode_label'),
          'value': devMode === '1',
        },
      },
      'form': {
        'submit_class': 'd-none',
      },
    });

    $container.find('div.cloud-col-2').append(form.render());

    form.$.find('.element_dev_mode input').on('change', function() {
      let value = jQuery(this).is(':checked') ? '1' : '0';
      UserPrefRepo.save('dev-mode', {'enabled': value}).then(() => {
        Notifier.success(Translator.translate('parameters_saved'));
      });
    });
  });

  return $container;
};
